{
  "footer-powered-by": "Powered by ",
  "footer-extra": ", a Boise ID company",
  "copyright": "Copyright © {{year}} Salt Technologies LLC.",
  "loading": "Loading…",
  "errorTitle": "Couldn't Load This Page",
  "networkError": "Check your connection and try again.",
  "retry": "Try Again",
  "footer-get-app": "Download the <ios>iOS</ios> or <android>Android</android> app to see more from your church."
}
